import { FilterDataType, FilterValueType, ProductFilter, ProductKey } from "app/shared/model/ProductBase";
import DateHelper, { CompareTypes } from "./dateHelper";

const getFieldValue = (filters:ProductFilter[], fieldName: string, defaultValue: any = [], valueType: FilterValueType = FilterValueType.primaryValue) => {
    let filter = filters.filter(f => f.fieldName === fieldName);

    if(filter && filter.length > 0)
        return (valueType === FilterValueType.primaryValue) 
                    ? filter[0].fieldValue
                    : filter[0].fieldSecondValue;

    return defaultValue;
}

const getFilters = (filterList: ProductFilter[] = [], value: any[] = [], field: (keyof ProductKey), valueType: FilterValueType = FilterValueType.primaryValue) => {
    if (!Array.isArray(value)) value = value !== undefined && value !== null ? [value] : [];

    if(value.length > 0)
    {
        //Add / Update Filter
        var filterIndex = filterList.findIndex((f) => {return f.fieldName === field});
        if(filterIndex >= 0)
        {
            //Update
            (valueType === FilterValueType.primaryValue)
                ? filterList[filterIndex].fieldValue = value
                : filterList[filterIndex].fieldSecondValue = value;                
        }
        else
        {
            //Add     
            (valueType === FilterValueType.primaryValue)        
                ? filterList.push({fieldName: field, fieldValue: value})
                : filterList.push({fieldName: field, fieldValue: [], fieldSecondValue: value});
        }
    }
    else
    {
        //Remove if exists
        filterList = filterList.filter(f => f.fieldName !== field);
    }

    return filterList;
}

const multipleFilter = <T, >(data:T[], filters: ProductFilter[]) => {

    filters.forEach((f) => {
        let field = f.fieldName as keyof T;
        data = (!f.fieldSecondValue)
            ? singleFilterArray(data, f.fieldValue, field)
            : singleFilterArray(data, f.fieldValue, field, f.fieldSecondValue);
    });

    return data;
}

const singleFilterArray = <T, >(data:T[], value: any[], field: (keyof T), secondValue?: any) => {
    data = data.filter((element) => {

        let id = parseInt(value[0]);

        let match = false;

        if(typeof(element[field]) === 'number' && !isNaN(id))
        {
            match = value.includes(element[field] as unknown as number);
        }

        if(!match && typeof(element[field]) === 'boolean')
        {
            match = value.includes(element[field] as unknown as boolean);
        }

        if(!match && typeof(element[field]) === 'string')
        {
            value.forEach(v => {
                const fieldValue = (element[field] as unknown as string)?.toLocaleLowerCase() || '';
                const filterValue = (typeof v === 'string' ? v : String(v))?.toLocaleLowerCase() || '';
                if(fieldValue.includes(filterValue))
                    match = true;
            });
        }

        if(!match && typeof(element[field]) === 'object' && !isNaN(Date.parse(element[field] as unknown as string)))
        {
            let fieldDate = new Date(element[field] as unknown as string);
            let secondaryDateValue = !isNaN(Date.parse(secondValue as unknown as string)) ? new Date(secondValue) : undefined;

            let dateValue = !isNaN(Date.parse(value[0] as unknown as string)) ? new Date(value[0]) : undefined;

            if(secondaryDateValue && dateValue)
            {
                if(DateHelper.CompareDates_Between(fieldDate, dateValue, secondaryDateValue))
                    match = true;
            }
            else if (dateValue)
            {
                if(DateHelper.CompareDates(fieldDate, dateValue, CompareTypes.BiggerThanOrEqualTo))
                    match = true;
            }
            else if(secondaryDateValue)
            {
                if(DateHelper.CompareDates(fieldDate, secondaryDateValue, CompareTypes.SmallerThanOrEqualTo))
                    match = true;
            }
        }

        return match;

    });

    return data;
}

const singleFilter = <T, >(data:T[], value: string, field: (keyof T)) => {
    
    let id = parseInt(value);

    data = data.filter((element) => {
        let match = false;

        if(typeof(element[field]) === 'number' && !isNaN(id))
        {
            match = (element[field] as unknown as number === id);
        }

        if(!match && typeof(element[field]) === 'string')
        {
            match = (element[field] as unknown as string).toLocaleLowerCase().includes(value.toLowerCase());
        }

        if(!match && element[field] === null && value === undefined)
        {
            match = (element[field] === null && value === undefined);
        }

        return match;
    });

    return data;
}

const filterHelper = {multipleFilter, singleFilter, singleFilterArray, getFilters, getFieldValue};

export default filterHelper;